module.exports = __webpack_public_path__ + "img/pause-icon-disable.bae0d2bd.svg";